var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25215 4.88418C6.50117 4.74141 6.80996 4.71816 7.05566 4.89746L11.8369 7.81934C12.0727 7.96543 12.2188 8.22109 12.2188 8.5C12.2188 8.77891 12.0727 9.03457 11.8369 9.18066L7.05566 12.1025C6.80996 12.252 6.50117 12.2586 6.25215 12.1158C5.9998 11.9764 5.84375 11.7107 5.84375 11.4219V5.54824C5.84375 5.28926 5.9998 5.02363 6.25215 4.88418ZM17 8.5C17 13.1949 13.1949 17 8.5 17C3.80508 17 0 13.1949 0 8.5C0 3.80508 3.80508 0 8.5 0C13.1949 0 17 3.80508 17 8.5ZM8.5 1.59375C4.68496 1.59375 1.59375 4.68496 1.59375 8.5C1.59375 12.315 4.68496 15.4062 8.5 15.4062C12.315 15.4062 15.4062 12.315 15.4062 8.5C15.4062 4.68496 12.315 1.59375 8.5 1.59375Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.4988b481.svg";
export { ForwardRef as ReactComponent };